var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldPlayAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.73 2.03c-6.1-.44-11.14 4.61-10.7 10.7.32 4.51 3.77 8.33 8.22 9.11 1.15.2 2.27.2 3.34.02.31-.05.49-.39.37-.67-.3-.68-.46-1.43-.46-2.2 0-1.69.75-3.25 2.07-4.29.97-.78 2.19-1.21 3.43-1.21.78 0 1.52.16 2.19.46.29.13.62-.06.68-.37.18-1.06.18-2.18-.02-3.33-.78-4.45-4.61-7.9-9.12-8.22zm.57 12.23-1.2.69c-1.49.86-2.71.16-2.71-1.57V10.61c0-1.72 1.22-2.43 2.71-1.57l1.2.69 1.2.69c1.49.88 1.49 2.28 0 3.15l-1.2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.88A3.97 3.97 0 0 0 15 19c0 .75.21 1.46.58 2.06A3.97 3.97 0 0 0 19 23c1.01 0 1.93-.37 2.63-1 .31-.26.58-.58.79-.94.37-.6.58-1.31.58-2.06a3.999 3.999 0 0 0-6.5-3.12zm3.25 3.85v.78c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.78h-.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.75v-.71c0-.41.34-.75.75-.75s.75.34.75.75v.71h.75c.41 0 .75.34.75.75s-.34.75-.75.75h-.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldPlayAdd);
export default __webpack_public_path__ + "static/media/vuesax-bold-play-add.23ac2ffc53a1e52d3d5b052d21a1eb28.svg";
export { ForwardRef as ReactComponent };